import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* undoWithdrawalFromSavings(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_REQUEST
    })

    const res = yield call(Http.delete, `charges/${action.payload?.chargeId}/undo-withdrawal`, {});
    
    yield put({
      type: Constants.GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_SUCCESS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUndoWithdrawalFromSavings() {
  yield takeEvery(Constants.GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_START, undoWithdrawalFromSavings);
}
